import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 's-corp-addons',
  pageKeys: [
    PAGE_KEYS.CONFIRMATION,
    PAGE_KEYS.BUSINESS_LICENSE_REPORT,
    PAGE_KEYS.DOMAIN_NAME_REGISTRATION,
    PAGE_KEYS.WEBSITE_BUILDER,
    PAGE_KEYS.CHECKOUT,
    PAGE_KEYS.CONCLUSION
  ],
  pageConfigs: {
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            businessInfoFields: {
              businessName: {
                disabled: true
              }
            }
          },
          listCallout: {
            showFilingGuarantee: false
          },
          pageHeader: {
            showSubtitle: false
          }
        }
      }
    }
  },
  authPolicy: AUTH_POLICY.REQUIRED,
  autoLoadBusiness: true,
  autoResume: false,
  entityType: 'llc',
  isSCorp: true,
  postOrderRedirect: ROUTES.UJM_COMPLETE_FORMATION,
  priceListUuids: {
    development: '2485c5df-45e7-43e4-a414-6edbc677d643', // Using S-Corp price list UUID
    production: '280d59c9-2b27-4fd6-bca0-e004349a0068' // Using S-Corp price list UUID
  },
  requiredEntitlements: ['formation_llc']
});
